import React, { FC, useState, useEffect } from 'react';
import {
  Lights,
  CanvasBackground,
  Planet,
  Dialog,
} from '../../../../components';
import { BouncingGlyph } from './BouncingGlyph';
import { NUM_LEVELS_PER_STAGE, STAGES, STORY } from '../../../../traits';
import { useCamera } from '../../../../utils';

export type DialogCutSceneProps = {
  level: number;
  matrix: number[][];
  colors: string[];
  onComplete?: () => void;
};
export const DialogCutScene: FC<DialogCutSceneProps> = ({
  level,
  matrix,
  colors,
  onComplete,
}) => {
  useCamera([0, -17, 0], [0, 0, 0], 60);
  const stageIdx = Math.floor(level / NUM_LEVELS_PER_STAGE);
  const stage = STAGES[stageIdx];

  const script = STORY.chapters[stageIdx];
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const advance = () => {
      if (index < script.length - 1) {
        setIndex(index + 1);
      } else if (onComplete) {
        onComplete();
      }
    };
    window.addEventListener('click', advance);
    window.addEventListener('keypress', advance);
    return () => {
      window.removeEventListener('click', advance);
      window.removeEventListener('keypress', advance);
    };
  }, [index, onComplete, script.length]);

  return (
    <>
      <Lights />
      <BouncingGlyph
        matrix={matrix}
        colors={colors}
        position={[-13, 2, -2]}
        rotation={[Math.PI / 2, 0.1, 0]}
      />
      <Planet {...stage.levels[0].planet} position={[280, 500, 120]} />
      <CanvasBackground texture={stage.background} />
      <Dialog
        position={[5, 0, -5]}
        size={[16, 6]}
        canvasSize={[160, 60]}
        text={script[index]}
        background="white"
      />
    </>
  );
};
